/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	handlePost: () => void,
	disabled: boolean,
	accuracy: number,
}
const MBFooter: React.FC<Props> = ({ handlePost, disabled, accuracy }) => {
	const { t } = useTranslation();
	return (
		<footer className="fixed bottom-0 right-0 left-64 bg-white border-t border-gray-200 px-8 py-4 flex items-center justify-between z-40 shadow-[0_-10px_20px_-15px_rgba(0,0,0,0.1)]">
			<div className="text-right">
				<p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">
					{t("mediaReconcile.mediaBatch.batchReconciliationStatus")}
				</p>
				<p className="text-lg font-black text-emerald-500">
					{accuracy}% {t("mediaReconcile.mediaBatch.accuracy")}
				</p>
			</div>
			<button
				// disabled={disabled}
				// disabled
				onClick={handlePost}
				className="flex items-center gap-2 px-6 py-2.5 bg-[#FF7043] text-white rounded-lg font-black text-[11px] uppercase tracking-widest shadow-lg shadow-orange-500/30 hover:brightness-110 active:scale-95 transition-all border-none disabled:opacity-30"
			>
				<span className="material-symbols-outlined text-base">
					check_circle
				</span>
				{t("mediaReconcile.mediaBatch.postReconciliation")}
			</button>
		</footer>
	);
};

export default MBFooter;
